export class WeekDaysToNumberConverter {
    convertWeekDaysToNumber(weekDays: string[]): string {
        let activeDaysInString: string = "";
        
        if (weekDays.length !== 0) {
            weekDays.forEach((weekDayItem: string) => {
                if (activeDaysInString !== "") {
                    activeDaysInString = activeDaysInString.concat(",");
                }
                switch (weekDayItem) {
                    case "Su":
                        {
                            activeDaysInString = activeDaysInString.concat("1");
                            break;
                        }
                    case "M":
                        {
                            activeDaysInString = activeDaysInString.concat("2");
                            break;
                        }
                    case "Tu":
                        {
                            activeDaysInString = activeDaysInString.concat("3");
                            break;
                        }
                    case "W":
                        {
                            activeDaysInString = activeDaysInString.concat("4");
                            break;
                        }
                    case "T":
                        {
                            activeDaysInString = activeDaysInString.concat("5");
                            break;
                        }
                    case "F":
                        {
                            activeDaysInString = activeDaysInString.concat("6");
                            break;
                        }
                    case "S":
                        {
                            activeDaysInString = activeDaysInString.concat("7");
                            break;
                        }
                    default:
                        {
                        }
                }
            });
        }
        else {
            activeDaysInString = "0";
        }
        return activeDaysInString;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/timebasedsetting/weekdaystonumberconverter.tsx